var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeIcon = function SvgVolumeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.703 13.107a1.1 1.1 0 0 1-.434-.094l-5.953-2.7H2.003c-.58 0-1.05-.47-1.05-1.05V4.735c0-.58.47-1.05 1.05-1.05h1.314L9.27.985c.327-.148.702-.12 1.003.073.302.194.482.524.482.883v10.114c0 .358-.18.69-.482.883-.17.11-.367.169-.57.169m-7.35-4.194h1.04q.226 0 .432.092l5.528 2.508V2.485L3.827 4.993a1.05 1.05 0 0 1-.435.094H2.353zm10.5 1.936a.7.7 0 0 1-.7-.7v-6.3a.7.7 0 0 1 1.4 0v6.3a.7.7 0 0 1-.7.7"
  })));
};
export default SvgVolumeIcon;